import { Styles } from "@mcleod/core";

export const TableHeadingRowStyles = Styles.make("thr", () => {
    const result = {
        base: {
            display: "table",
            width: "100%",
            tableLayout: "fixed",
            borderSpacing: "0px",
            paddingTop: "2px",
            paddingBottom: "2px"
        }
    }
    return result;
});
